export default __webpack_public_path__ + "static/media/secure-job.7c9e044b.png";